var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.2002L13 4.2002M13 4.2002C13 5.85705 14.3431 7.2002 16 7.2002C17.6569 7.2002 19 5.85705 19 4.2002C19 2.54334 17.6569 1.2002 16 1.2002C14.3431 1.2002 13 2.54334 13 4.2002ZM7 12.2002L19 12.2002M7 12.2002C7 13.857 5.65685 15.2002 4 15.2002C2.34315 15.2002 1 13.857 1 12.2002C1 10.5433 2.34315 9.2002 4 9.2002C5.65685 9.2002 7 10.5433 7 12.2002Z",
    stroke: "#118F84",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.a929ecf7055fa591ad8e0b3f35617d4f.svg";
export { ForwardRef as ReactComponent };